
define('jst!tooltips/_no_name',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class=\'org-list-name-hidden-tooltip\'>\n  <div class=\'text-bold title\'><%= t("Hidden workspace name #user_admin_v2") %></div>\n  <p><%= t("You can\'t see this name because you don\'t have access to this workspace #user_admin_v2") %></p>\n</div>\n');
 });

